<template>
  <div class="calendar-component">
    <div class="calendar">
      <v-calendar
        :attributes="attrs"
        :disabled-dates="disabledDates"
        :masks="masks"
        ref="calendar"
        title-position="center"
        color="green"
        @dayclick="selectDate"
        @update:from-page="getAppointments"
        @update:to-page="getAppointments"
      />
      <div class="key d-grid gap-2 align-items-center">
        <div class="d-flex gap-2">
          <div class="circle today"></div>
          <span class="font-size-12">Today</span>
        </div>
        <div class="d-flex gap-2">
          <div class="circle unavailable"></div>
          <span class="font-size-12">Unavailable</span>
        </div>
        <div class="d-flex gap-2">
          <div class="circle appointment"></div>
          <span class="font-size-12">Existing Appointment</span>
        </div>
        <div class="d-flex gap-2">
          <div class="circle fully-booked"></div>
          <span class="font-size-12">Fully Booked</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      attrs: null,
      calendar: null,
      selectedDate: null,
      selectedAppointments: null,
      currentYear: null,
      currentMonth: null,
      disabledDates: [],
      attendeeUserIds: null,
      appointmentType: null,
      masks: {
        weekdays: "WW",
      }
    };
  },

  props: {
    page: {
      type: Boolean,
      default: false,
    },
    existingAttendeeUserIds: {
      type: Array,
      default: () => [],
    },
    noSelect: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    window.addEventListener('attendeeUsersUpdated', this.updateAttendeeUserIds);

  },
  created() {
    // Get reference to the calendar component.
    this.calendar = this.$refs.calendar;

    if (this.existingAttendeeUserIds.length > 0) {
      this.attendeeUserIds = this.existingAttendeeUserIds;
    }

    this.getAppointments();
  },

  methods: {
    selectDate(data) {
      if (this.noSelect) {
        return;
      }

      this.selectedDate = data;
      this.selectedAppointments = null;
      this.loading = true;
      const event = new CustomEvent('dateUpdated', {
        detail: this.$moment(this.selectedDate.date)
      });

      // Dispatch the event
      window.dispatchEvent(event);

      let ids = [];
      for (const attr in data.attributes) {
        if (data.attributes[attr].key === 'today') {
          continue;
        }

        ids.push(data.attributes[attr].key);
      }

      if (this.page) {

        for (const x in ids) {
          $(`.calendar-page .event[data-id=${ids[x]}]`).addClass('active');
        }

        if (ids.length > 0) {
          $(`.calendar-page .event[data-id=${ids[0]}]`)[0].scrollIntoView();
        }

        return;
      }

      axios.post(window.api_url + '/admin/appointments/details', {
        ids: ids,
      })
      .then(res => {
        if (res.data && res.data.success) {
          this.selectedAppointments = res.data.appointments;
          this.$root.$emit('updateAppointments', res.data.appointments);
        }
      })
      .catch(err => {
        //
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getAppointments(data = null) {
      this.loading = true;
      this.attrs = null;
      this.disabledDates = [];

      this.currentYear = data ? data.year : this.currentYear;
      this.currentMonth = data ? data.month : this.currentMonth;

      axios.post(window.api_url + '/admin/appointments/calendar', {
          date: {
            month: this.currentMonth,
            year: this.currentYear,
          },
          user_ids: this.attendeeUserIds,
        })
        .then(res => {
          if (res.data && res.data.success) {
            this.attrs = res.data.attrs;
            this.disabledDates = res.data.disabledDates;
          }
        })
        .catch(err => {
          //
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateAttendeeUserIds(e) {
      this.attendeeUserIds = e.detail;
      this.getAppointments();
    },
  },
};
</script>
